var _g, _circle, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBallUndefined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 300,
    viewBox: "0 0 288 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1002_609)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint0_radial_1002_609)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1002_609",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 20,
    width: 240,
    height: 240
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint1_radial_1002_609)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1002_609)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144.002,
    cy: 140,
    r: 120,
    fill: "url(#paint2_radial_1002_609)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1002_609)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.502 27.5151C85.2276 27.515 31.5018 81.2408 31.5018 147.515C31.5018 178.705 43.4012 207.116 62.9079 228.455C38.9927 206.519 23.9999 175.01 23.9999 140C24 73.7262 77.7258 20.0004 144 20.0004C179.084 20.0004 210.652 35.0567 232.594 59.0603C211.237 39.4711 182.766 27.5151 151.502 27.5151Z",
    fill: "url(#paint3_radial_1002_609)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1002_609)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.073 125C255.692 184.195 205.196 230 144.002 230C82.8077 230 32.3118 184.195 24.9304 125C24.3176 129.914 24.002 134.92 24.002 140C24.002 206.274 77.7278 260 144.002 260C210.276 260 264.002 206.274 264.002 140C264.002 134.92 263.686 129.914 263.073 125Z",
    fill: "url(#paint4_radial_1002_609)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1002_609)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.668,
    cy: 116.668,
    r: 43.3333,
    fill: "#686868"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1002_609)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.669,
    cy: 103.335,
    r: 30,
    fill: "#ADADAD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1002_609",
    x: 0,
    y: 0,
    width: 288,
    height: 300,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0627451 0 0 0 0 0.0666667 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_609"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.678431 0 0 0 0 0.678431 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1002_609",
    result: "effect2_dropShadow_1002_609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1002_609",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1002_609",
    x: 8,
    y: 4,
    width: 240.594,
    height: 240.455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_1002_609"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1002_609",
    x: 8.00195,
    y: 109,
    width: 272,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_1002_609"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1002_609",
    x: 113.335,
    y: 49.335,
    width: 134.667,
    height: 134.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1002_609"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1002_609",
    x: 126.669,
    y: 49.335,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1002_609"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1002_609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189 110) rotate(63.435) scale(83.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1002_609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144 140) rotate(46.3972) scale(96.6666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DAFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934818,
    stopColor: "#127BAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1002_609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.002 140) rotate(46.3972) scale(96.6666)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934818,
    stopColor: "#2B2A2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1002_609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.03 139.969) rotate(-133.616) scale(96.6662 96.6684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934818,
    stopColor: "#686868"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1002_609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.002 140) rotate(46.3973) scale(96.6668 96.6668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1B191A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallUndefined);
export default __webpack_public_path__ + "static/media/ball_undefined.b612f98bdfed322ac4d4e1a65a18969b.svg";
export { ForwardRef as ReactComponent };